import { all, takeEvery, fork, call, put } from 'redux-saga/effects';
import axios from 'axios';
import isFunction from 'lodash/isFunction';

import actions from './actions';
import { handleError } from '../../errorHandler';
import { API_HOST } from '../../constants';

function* createMemberTagFilter() {
  yield takeEvery(actions.CREATE_MEMBER_TAG_FILTER, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call([axios, 'post'], `${API_HOST}/api/memberTagFilter`, data);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.CREATE_MEMBER_TAG_FILTER_ENDED });
    }
  });
}

function* searchMemberTagFilters() {
  yield takeEvery(actions.SEARCH_MEMBER_TAG_FILTERS, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'get'],
        `${API_HOST}/api/memberTagFilter?${parameters.toString()}`,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.SEARCH_MEMBER_TAG_FILTERS_ENDED });
    }
  });
}

function* findMemberTagFilter() {
  yield takeEvery(actions.FIND_MEMBER_TAG_FILTER, function* (action) {
    const { id, onSuccess } = action;
    try {
      const res = yield call([axios, 'get'], `${API_HOST}/api/memberTagFilter/${id}`);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.FIND_MEMBER_TAG_FILTER_ENDED });
    }
  });
}

function* updateMemberTagFilter() {
  yield takeEvery(actions.UPDATE_MEMBER_TAG_FILTER, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call([axios, 'put'], `${API_HOST}/api/memberTagFilter`, data);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.UPDATE_MEMBER_TAG_FILTER_ENDED });
    }
  });
}

function* deleteMemberTagFilters() {
  yield takeEvery(actions.DELETE_MEMBER_TAG_FILTERS, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call([axios, 'delete'], `${API_HOST}/api/memberTagFilter`, { data });
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.DELETE_MEMBER_TAG_FILTERS_ENDED });
    }
  });
}

function* triggerMemberTagFilters() {
  yield takeEvery(actions.TRIGGER_MEMBER_TAG_FILTER, function* (action) {
    const { id, onSuccess } = action;
    try {
      const res = yield call([axios, 'post'], `${API_HOST}/api/memberTagFilter/${id}/trigger`);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.TRIGGER_MEMBER_TAG_FILTER_ENDED });
    }
  });
}

function* searchMemberTagFilterTriggerRecords() {
  yield takeEvery(actions.SEARCH_MEMBER_TAG_FILTER_TRIGGER_RECORDS, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'get'],
        `${API_HOST}/api/memberTagFilter/trigger/record?${parameters.toString()}`,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.SEARCH_MEMBER_TAG_FILTER_TRIGGER_RECORDS_ENDED });
    }
  });
}

export default function* rootSaga() {
  yield all([
    fork(createMemberTagFilter),
    fork(searchMemberTagFilters),
    fork(findMemberTagFilter),
    fork(updateMemberTagFilter),
    fork(deleteMemberTagFilters),
    fork(triggerMemberTagFilters),
    fork(searchMemberTagFilterTriggerRecords),
  ]);
}
